(() => {
  const revealAll = () => document.querySelectorAll('.ya-reveal').forEach((el) => el.classList.add('is-in'));

  const initReveal = () => {
    const items = document.querySelectorAll('.ya-reveal:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealAll();
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((el) => observer.observe(el));
  };

  const initHeader = () => {
    const header = document.querySelector('[data-ya-header]');
    if (!header) return;

    // Horizon scrolls inside .page-wrapper from 990px up, and the window below that
    const scroller = document.querySelector('.page-wrapper');
    if (!header.classList.contains('ya-header--solid')) {
      const update = () => header.classList.toggle('is-solid', Math.max(window.scrollY, scroller ? scroller.scrollTop : 0) > 24);
      update();
      window.addEventListener('scroll', update, { passive: true });
      scroller?.addEventListener('scroll', update, { passive: true });
    }

    const drawer = document.querySelector('[data-ya-drawer]');
    const openBtn = header.querySelector('[data-ya-open]');
    if (!drawer || !openBtn) return;
    const closeBtn = drawer.querySelector('[data-ya-close]');

    const close = () => {
      drawer.classList.remove('is-open');
      document.body.classList.remove('ya-locked');
      openBtn.setAttribute('aria-expanded', 'false');
      window.setTimeout(() => { drawer.hidden = true; }, 320);
      openBtn.focus();
    };
    const open = () => {
      drawer.hidden = false;
      document.body.classList.add('ya-locked');
      openBtn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      closeBtn?.focus();
    };

    openBtn.addEventListener('click', open);
    closeBtn?.addEventListener('click', close);
    drawer.querySelectorAll('a').forEach((a) => a.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });
  };


  // Video player: [data-ya-play] points to a <template> holding the video with sound
  let modal;
  const getModal = () => {
    if (modal) return modal;
    modal = document.createElement('dialog');
    modal.className = 'ya-modal';
    modal.setAttribute('aria-label', 'Lecteur vidéo');
    modal.innerHTML = '<button class="ya-modal__close" type="button" aria-label="Fermer la vidéo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button><div class="ya-modal__frame"></div>';
    document.body.append(modal);
    const frame = modal.querySelector('.ya-modal__frame');
    modal.querySelector('.ya-modal__close').addEventListener('click', () => modal.close());
    modal.addEventListener('click', (e) => { if (e.target === modal) modal.close(); });
    modal.addEventListener('close', () => {
      frame.replaceChildren();
      document.querySelectorAll('.ya-bg-video').forEach((v) => { if (!reduceMotion()) v.play().catch(() => {}); });
      lastTrigger?.focus();
    });
    return modal;
  };
  let lastTrigger;
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-ya-play]');
    if (!trigger) return;
    const tpl = document.getElementById(trigger.dataset.yaPlay);
    if (!tpl) return;
    e.preventDefault();
    lastTrigger = trigger;
    const dialog = getModal();
    const frame = dialog.querySelector('.ya-modal__frame');
    frame.replaceChildren(tpl.content.cloneNode(true));
    document.querySelectorAll('.ya-bg-video').forEach((v) => v.pause());
    dialog.showModal();
    const video = frame.querySelector('video');
    if (video) { video.muted = false; video.play().catch(() => {}); }
  });

  // Testimonial rail arrows
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ya-rail-prev], [data-ya-rail-next]');
    if (!btn) return;
    const rail = document.getElementById(btn.dataset.yaRailPrev || btn.dataset.yaRailNext);
    const card = rail?.querySelector('li');
    if (!rail || !card) return;
    const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0);
    rail.scrollBy({ left: btn.dataset.yaRailPrev ? -step : step, behavior: reduceMotion() ? 'auto' : 'smooth' });
  });

  // Offer cards: the whole front opens the card, the back holds the prices
  const setFlip = (card, open) => {
    const front = card.querySelector('.ya-flip__front');
    const back = card.querySelector('.ya-flip__back');
    const btn = card.querySelector('[data-ya-flip-open]');
    card.classList.toggle('is-flipped', open);
    front.inert = open;
    back.inert = !open;
    btn?.setAttribute('aria-expanded', String(open));
    const target = open ? back.querySelector('a, button') : btn;
    window.setTimeout(() => target?.focus({ preventScroll: true }), reduceMotion() ? 0 : 450);
  };
  document.addEventListener('click', (e) => {
    const close = e.target.closest('[data-ya-flip-close]');
    if (close) { setFlip(close.closest('[data-ya-flip]'), false); return; }
    const front = e.target.closest('.ya-flip__front');
    if (front) { e.preventDefault(); setFlip(front.closest('[data-ya-flip]'), true); }
  });

  // Formules cards: both backs take the height of the longest one, so the two plans line up
  const syncFlipBacks = () => {
    document.querySelectorAll('.ya-flips').forEach((grid) => {
      const backs = [...grid.querySelectorAll('.ya-flip--rich .ya-flip__back')];
      if (backs.length < 2) return;
      // A back that is not turned is squeezed to the front's height: free its bottom edge while measuring
      backs.forEach((b) => { b.style.minHeight = ''; b.style.bottom = 'auto'; });
      const tallest = Math.ceil(Math.max(...backs.map((b) => b.getBoundingClientRect().height)));
      backs.forEach((b) => { b.style.bottom = ''; b.style.minHeight = `${tallest}px`; });
    });
  };
  let flipFrame;
  const queueFlipSync = () => { cancelAnimationFrame(flipFrame); flipFrame = requestAnimationFrame(syncFlipBacks); };
  window.addEventListener('resize', queueFlipSync);
  window.addEventListener('load', queueFlipSync);
  document.addEventListener('load', (e) => { if (e.target.closest?.('.ya-flip--rich')) queueFlipSync(); }, true);

  // Plan comparison: one tab per trade, arrows move between tabs
  const setTab = (tab) => {
    const list = tab.closest('[role="tablist"]');
    list.querySelectorAll('[data-ya-tab]').forEach((t) => {
      const on = t === tab;
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
    });
  };
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-ya-tab]');
    if (tab) setTab(tab);
  });
  document.addEventListener('keydown', (e) => {
    const tab = e.target.closest('[data-ya-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[data-ya-tab]')];
    const next = tabs[(tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    setTab(next);
    next.focus();
  });

  // Career path: the line fills as the steps scroll past the middle of the screen
  const initPath = () => {
    const paths = document.querySelectorAll('[data-ya-path]');
    if (!paths.length) return;
    if (reduceMotion()) { paths.forEach((p) => p.style.setProperty('--ya-p', '1')); return; }
    let ticking = false;
    const update = () => {
      ticking = false;
      const anchor = window.innerHeight * 0.6;
      paths.forEach((p) => {
        const r = p.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, (anchor - r.top) / r.height));
        p.style.setProperty('--ya-p', progress.toFixed(3));
      });
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    document.querySelector('.page-wrapper')?.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  };

  // Background video: no autoplay for reduced motion
  const initBgVideo = () => {
    document.querySelectorAll('.ya-bg-video').forEach((v) => {
      v.muted = true;
      if (reduceMotion()) { v.removeAttribute('autoplay'); v.pause(); }
    });
  };

  // Hero sound: try to start the presentation with sound at medium volume; if the browser blocks it,
  // start muted and turn the sound on at the visitor's first click, tap or key press
  const HERO_VOLUME = 0.5;
  const initHeroSound = () => {
    const btn = document.querySelector('[data-ya-sound]');
    const video = btn?.closest('.ya-hero')?.querySelector('.ya-bg-video');
    if (!video) return;
    const render = () => {
      const on = !video.muted;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute('aria-label', on ? btn.dataset.labelOn : btn.dataset.labelOff);
    };
    const unmute = async () => {
      video.muted = false;
      video.volume = HERO_VOLUME;
      try { await video.play(); } catch { video.muted = true; }
      render();
    };
    const events = ['pointerup', 'keydown', 'touchend'];
    const onFirstGesture = (e) => {
      if (e.target.closest('[data-ya-sound], [data-ya-play]')) return;
      events.forEach((t) => document.removeEventListener(t, onFirstGesture, true));
      if (video.muted && !video.paused) unmute();
    };
    btn.addEventListener('click', () => {
      events.forEach((t) => document.removeEventListener(t, onFirstGesture, true));
      if (video.muted) { unmute(); return; }
      video.muted = true;
      render();
    });
    render();
    // Pause while the hero is off screen so the sound does not follow the visitor down the page
    const hero = btn.closest('.ya-hero');
    new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) { video.pause(); return; }
      if (!reduceMotion() && !document.querySelector('.ya-modal[open]')) video.play().catch(() => {});
    }, { threshold: 0.2 }).observe(hero);
    if (btn.dataset.yaSound !== 'auto' || reduceMotion()) return;
    video.muted = false;
    video.volume = HERO_VOLUME;
    video.play().then(render).catch(() => {
      video.muted = true;
      video.play().catch(() => {});
      render();
      events.forEach((t) => document.addEventListener(t, onFirstGesture, true));
    });
  };

  // Gallery filters: show only the photos of the chosen category
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ya-filter]');
    if (!btn) return;
    const box = btn.closest('.ya-gallery');
    const cat = btn.dataset.yaFilter;
    box.querySelectorAll('[data-ya-filter]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
    box.querySelectorAll('.ya-gallery__item').forEach((item) => { item.hidden = cat !== '' && item.dataset.cat !== cat; });
  });

  // Before / after carousel: crossfade every few seconds, dots to pick a photo, paused on hover and off screen
  const CAROUSEL_DELAY = 4000;
  const initCarousels = () => {
    document.querySelectorAll('[data-ya-carousel]:not([data-ready])').forEach((box) => {
      box.dataset.ready = '';
      const slides = [...box.querySelectorAll('.ya-shift__slide')];
      if (slides.length < 2) return;
      const dots = document.createElement('div');
      dots.className = 'ya-shift__dots';
      dots.setAttribute('role', 'group');
      dots.setAttribute('aria-label', 'Photos');
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ya-shift__dot';
        dot.setAttribute('aria-label', `Photo ${i + 1} sur ${slides.length}`);
        dot.addEventListener('click', () => { show(i); restart(); });
        dots.append(dot);
      });
      box.append(dots);
      let current = 0;
      let timer;
      let visible = false;
      let hovered = false;
      const show = (i) => {
        current = (i + slides.length) % slides.length;
        const next = slides[(current + 1) % slides.length];
        if (next.loading === 'lazy') next.loading = 'eager';
        slides.forEach((s, k) => s.classList.toggle('is-active', k === current));
        [...dots.children].forEach((d, k) => d.setAttribute('aria-current', String(k === current)));
        box.classList.toggle('is-first', current === 0);
      };
      const stop = () => { clearInterval(timer); timer = undefined; };
      const restart = () => {
        stop();
        if (reduceMotion() || !visible || hovered) return;
        timer = setInterval(() => show(current + 1), CAROUSEL_DELAY);
      };
      box.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { hovered = true; stop(); } });
      box.addEventListener('pointerleave', () => { hovered = false; restart(); });
      new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; restart(); }, { threshold: 0.3 }).observe(box);
      show(0);
    });
  };

  // Crew dashboard: candidate profile and file, stored in a private Google Drive folder through an Apps Script web app
  const DOSSIER_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
  const PROFILE_REQUIRED = ['position', 'availability', 'program', 'nationality', 'languages', 'yacht_experience', 'trade_experience', 'stcw_expiry', 'eng1_expiry', 'references', 'about'];
  const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1] || '');
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
  const initCrew = () => {
    document.querySelectorAll('[data-ya-crew]').forEach((scope) => {
      const endpoint = scope.dataset.endpoint;
      const identity = { cid: scope.dataset.cid, email: scope.dataset.email, name: scope.dataset.name, token: scope.dataset.token };
      const messages = Object.fromEntries([...(scope.querySelector('[data-ya-dossier-messages]')?.content.querySelectorAll('[data-key]') || [])].map((m) => [m.dataset.key, m.textContent.trim()]));
      const root = scope.querySelector('[data-ya-dossier]');
      const form = scope.querySelector('[data-ya-profile]');
      const slots = root ? [...root.querySelectorAll('[data-slot]')] : [];
      const error = scope.querySelector('[data-ya-dossier-error]');
      const maxBytes = (Number(root?.dataset.max) || 10) * 1024 * 1024;
      const showError = (msg) => { if (!error) return; error.textContent = msg || ''; error.hidden = !msg; };
      const dateLabel = (iso) => new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(iso));
      let docsFilled = 0;
      let profile = {};

      const readForm = () => {
        const data = {};
        if (!form) return data;
        [...form.elements].forEach((el) => {
          if (!el.name) return;
          if (el.type === 'checkbox' && el.name === 'visible') data.visible = el.checked;
          else if (el.type === 'checkbox') { data[el.name] = data[el.name] || []; if (el.checked) data[el.name].push(el.value); }
          else data[el.name] = el.value.trim();
        });
        return data;
      };
      const fillForm = (p) => {
        if (!form) return;
        [...form.elements].forEach((el) => {
          if (!el.name || p[el.name] === undefined) return;
          if (el.type === 'checkbox' && el.name === 'visible') el.checked = !!p.visible;
          else if (el.type === 'checkbox') el.checked = Array.isArray(p[el.name]) && p[el.name].includes(el.value);
          else el.value = p[el.name];
        });
        markExpiry();
      };
      const markExpiry = () => {
        if (!form) return;
        const soon = Date.now() + 90 * 864e5;
        form.querySelectorAll('input[type="date"][name$="_expiry"]').forEach((input) => {
          const note = input.parentElement.querySelector('[data-ya-expiry]');
          const t = input.value ? new Date(input.value + 'T12:00:00').getTime() : NaN;
          note.textContent = Number.isNaN(t) ? '' : t < Date.now() ? messages.expiry_past : t < soon ? messages.expiry_soon : '';
          note.classList.toggle('is-past', t < Date.now());
        });
      };
      const updateCompletion = () => {
        const p = form ? readForm() : profile;
        const done = PROFILE_REQUIRED.filter((k) => p[k] && String(p[k]).trim()).length;
        const total = PROFILE_REQUIRED.length + slots.length;
        const pct = total ? Math.round(((done + docsFilled) / total) * 100) : 0;
        scope.querySelectorAll('[data-ya-profile-percent]').forEach((el) => { el.textContent = pct; });
        const pbar = scope.querySelector('[data-ya-profile-bar]');
        if (pbar) pbar.style.transform = `scaleX(${PROFILE_REQUIRED.length ? done / PROFILE_REQUIRED.length : 0})`;
      };

      const render = (files) => {
        docsFilled = 0;
        slots.forEach((slot) => {
          const mine = files.filter((f) => f.slot === slot.dataset.slot);
          const multi = slot.dataset.multi === 'true';
          slot.classList.remove('is-loading', 'is-sending');
          slot.classList.toggle('is-filled', mine.length > 0);
          if (mine.length) docsFilled += 1;
          const list = slot.querySelector('[data-ya-dossier-files]');
          list.replaceChildren(...mine.map((f) => {
            const li = document.createElement('li');
            const name = document.createElement('span');
            name.textContent = f.name;
            const meta = document.createElement('small');
            meta.textContent = dateLabel(f.date);
            li.append(name, meta);
            if (multi) {
              const rm = document.createElement('button');
              rm.type = 'button';
              rm.textContent = messages.remove;
              rm.addEventListener('click', () => send(slot, { action: 'delete', fileId: f.id }));
              li.append(rm);
            }
            return li;
          }));
          slot.querySelector('[data-ya-dossier-status]').textContent = mine.length ? '' : messages.empty;
          slot.querySelector('[data-ya-dossier-btn]').textContent = !mine.length ? messages.add : multi ? messages.more : messages.replace;
        });
        scope.querySelectorAll('[data-ya-dossier-count]').forEach((el) => { el.textContent = docsFilled; });
        const bar = scope.querySelector('[data-ya-dossier-bar]');
        if (bar) bar.style.transform = `scaleX(${slots.length ? docsFilled / slots.length : 0})`;
        updateCompletion();
      };

      const call = async (body) => {
        const r = await fetch(endpoint, { method: 'POST', headers: { 'content-type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ ...identity, ...body }) });
        const data = await r.json();
        if (!data.ok) throw Object.assign(new Error(data.error || 'error'), { code: data.error });
        return data;
      };
      const send = async (slot, body) => {
        slot.classList.add('is-sending');
        slot.querySelector('[data-ya-dossier-status]').textContent = messages.sending;
        showError('');
        try {
          render((await call(body)).files || []);
        } catch (err) {
          slot.classList.remove('is-sending');
          showError(err.code === 'bad_type' ? messages.error_type : err.code === 'bad_size' ? messages.error_size : err.code === 'too_many' ? messages.error_many : messages.error_send);
          slot.querySelector('[data-ya-dossier-status]').textContent = '';
        }
      };

      slots.forEach((slot) => {
        const input = slot.querySelector('[data-ya-dossier-input]');
        input.addEventListener('change', async () => {
          const files = [...input.files];
          input.value = '';
          for (const file of files) {
            const type = file.type || (/\.heic$/i.test(file.name) ? 'image/heic' : '');
            if (!DOSSIER_TYPES.includes(type)) { showError(messages.error_type); return; }
            if (file.size > maxBytes) { showError(messages.error_size); return; }
            await send(slot, { action: 'upload', slot: slot.dataset.slot, filename: file.name, mime: type, data: await fileToBase64(file) });
          }
        });
      });

      if (form) {
        const status = form.querySelector('[data-ya-profile-status]');
        const save = form.querySelector('[data-ya-profile-save]');
        form.addEventListener('input', () => { updateCompletion(); markExpiry(); status.textContent = ''; });
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          if (!endpoint || !identity.token) return;
          save.disabled = true;
          status.textContent = messages.saving;
          status.classList.remove('is-error');
          try {
            const data = await call({ action: 'saveProfile', profile: readForm() });
            profile = data.profile || {};
            if (data.files) render(data.files);
            status.textContent = messages.saved;
          } catch {
            status.textContent = messages.error_send;
            status.classList.add('is-error');
          }
          save.disabled = false;
        });
      }

      updateCompletion();
      if (!endpoint || !identity.token) {
        slots.forEach((slot) => { slot.classList.remove('is-loading'); slot.querySelector('[data-ya-dossier-status]').textContent = ''; });
        return;
      }
      call({ action: 'list' }).then((data) => {
        profile = data.profile || {};
        fillForm(profile);
        render(data.files || []);
      }).catch(() => {
        slots.forEach((slot) => { slot.classList.remove('is-loading'); slot.querySelector('[data-ya-dossier-status]').textContent = ''; });
        showError(messages.error_load);
      });
    });
  };

  const init = () => {
    initCrew();
    initCarousels();
    initHeader();
    initReveal();
    initBgVideo();
    initHeroSound();
    initPath();
    syncFlipBacks();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', initReveal);
})();
